import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

class Holiday2018 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

	render() {
		return <div className='Holiday2018'>
			<div className="promoBanner">
				<img className='desktop600' src="/img/promopages/holiday2018/landing_page_banner-a.jpg" alt="Diamonds Direct Holiday" />
				<img className='mobile600' src="/img/promopages/holiday2018/landing_page_mobile-a.jpg" alt="Diamonds Direct Holiday" />
			</div>
			<div className="promoBody">
				<div className="promoText">
					This winter, make all of their Sparkling Winter Wishes come true with our in-store exclusive Winter Event. Enjoy:
				</div>
				<div className="promoHighlightSection">
					20% Special Savings*
				</div>
				<div className="promoText" style={{margin: '0'}}>
					Internationally renowned designers have curated <span className='light-em'>exclusive collections</span> for each of our stores. Visit our locations to learn more!
				</div>
				<div className="summerLocationBlock">
					<div className="summerLocationItem">
						<div className="summerDates">Nov. 9-11</div>
						<div className="summerLocations">
							<a className="holiday-location-link" href="/columbus">Columbus,&nbsp;OH</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/virginia-beach">Virginia&nbsp;Beach,&nbsp;VA</a>							
						</div>
					</div>
					<div className="summerLocationItem">
						<div className="summerDates">Nov. 16-18</div>
						<div className="summerLocations">
							<a className="holiday-location-link" href="/charlotte">Charlotte,&nbsp;NC</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/jacksonville">Jacksonville,&nbsp;FL</a>
							<br />
							<a className="holiday-location-link" href="/birmingham">Birmingham,&nbsp;AL</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/dallas">Dallas,&nbsp;TX</a>
							<br />
							<a className="holiday-location-link" href="/indianapolis">Indianapolis,&nbsp;IN</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/richmond">Richmond,&nbsp;VA</a>
						</div>
					</div>
					<div className="summerLocationItem">
						<div className="summerDates">Nov. 30 - Dec. 2</div>
						<div className="summerLocations">
							<a className="holiday-location-link" href="/oklahoma-city">Oklahoma&nbsp;City,&nbsp;OK</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/sanantonio">San&nbsp;Antonio,&nbsp;TX</a>
							<br />
							<a className="holiday-location-link" href="/austin">Austin,&nbsp;TX</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/charleston">Charleston,&nbsp;SC</a>
							<br />
							<a className="holiday-location-link" href="/salt-lake-city">Salt&nbsp;Lake&nbsp;City,&nbsp;UT</a>
							&nbsp;<span className='link-em'>|</span>&nbsp;
							<a className="holiday-location-link" href="/raleigh">Raleigh,&nbsp;NC</a>
							<br />
							<a className="holiday-location-link" href="/st-louis">St.&nbsp;Louis,&nbsp;MO</a>
						</div>
					</div>
					<div className="summerLocationItem">
						<div className="summerDates">Dec. 7 - 9</div>
						<div className="summerLocations">
							<a className="holiday-location-link" href="/kansas-city">Kansas&nbsp;City,&nbsp;KS</a>
						</div>
					</div>
				</div>
				<div className='dislaimerLine'>* In-store only, excludes price protected lines and certified diamonds</div>
			</div>
		</div>;
	}
}
export default Holiday2018;

function mapStateToProps(state) {
  return {

  };
}

export const Holiday2018Container = connect(
  mapStateToProps,
  allActionCreators
)(Holiday2018);


// WEBPACK FOOTER //
// ./src/components/views/promopages/holiday2018/Holiday2018.jsx